import React from "react";

const RowTextAreaField = (props) => {
  const { fieldName, fieldLabel, fieldMandatory, data } = props;
  let defvalue = "";

  if (data && data.hasOwnProperty(fieldName)) {
    defvalue = data[fieldName];
    // Handle object values from API (extract the actual value)
    if (typeof defvalue === 'object' && defvalue !== null) {
      defvalue = defvalue.value || defvalue.label || '';
    }
  }

  return (
    <div className="mb-4">
      <label htmlFor={fieldName} className="block text-sm font-medium text-gray-700 mb-1 text-left">
        {fieldLabel}
        {fieldMandatory && <span className="text-red-500 ml-1">*</span>}
        }
      </label>
      <textarea
        id={fieldName}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-colors resize-vertical invalid:border-red-500 invalid:ring-red-500"
        placeholder={`Enter ${fieldLabel}`}
        name={fieldName}
        required={fieldMandatory}
        defaultValue={defvalue}
        rows="3"
      />
      <div className="invalid-feedback mt-1 text-xs text-red-600">
        {fieldLabel} is required.
      </div>
    </div>
  );
};

export default RowTextAreaField;